/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable no-extra-boolean-cast */
import React, {
  ChangeEvent,
  PropsWithChildren,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react'
import { Input, Spin, Form, notification, Tabs, Button, Space } from 'antd'
import { useTranslation } from 'react-i18next'
import dayjs from 'dayjs'
import { useQueryClient } from 'react-query'
import { DeleteTwoTone, CloseOutlined } from '@ant-design/icons'

import { useHandleDeleteTicketModal, useUser } from '@contexts'
import { useNote, useConfigurationProperties, useTicketsById } from '@hooks'
import { FormTypeSupplier, Note, RoleEnum, StatusTicketEnum, Ticket } from '@types'
import { QUERY_KEYS } from '@api'
import { NoteElement } from '@components'
import { ticketStatusToDisablePrimaryButtonforAdmin } from '@constants'

import { StyledButton, StyledModal, StyledRow, FlexRow } from '../StyledComponents'
import { useHandleTicketModal } from '../../contexts/HandleTicketModalContext'
import ShareTicket from '../ShareTicket'
import RedirectToTicket from '../RedirectToTicket'
import TicketForm from './components/TicketForm'

const { TextArea } = Input

const { ADMIN, SUPPLIER, ADMINRO } = RoleEnum
const { TICKET, PURCHASES } = QUERY_KEYS

const adminRoles = [ADMIN, ADMINRO]
const ableRolesToShare = [...adminRoles]
const { CREATED, PENDING, CONFIRMED } = StatusTicketEnum

const permittedAdminDeleteStatus = [PENDING, CONFIRMED]

const primaryButtonInitialStateByRole = (ticket: Ticket) => ({
  [ADMIN]: ticketStatusToDisablePrimaryButtonforAdmin.includes(
    ticket.status.name as StatusTicketEnum,
  ),
  [SUPPLIER]: !(ticket.status.name === CREATED && !!ticket.ticketAssignments?.length),
})

const today = dayjs()
const tomorrow = today.clone()
tomorrow.add(1, 'day').startOf('d')

type TabValue = '1' | '2'

type Props = {
  onOk: (
    id: number | undefined,
    form: FormTypeSupplier,
    resetForm: () => void,
    dates: Date[] | undefined,
    toApprove?: boolean | undefined,
  ) => void
  title: string
  isLoading: boolean
  autoAssignValue?: string | undefined
  onClose: (reset?: () => void) => void
}

const TicketModal: React.FC<Props> = ({ onClose, title, onOk, isLoading }) => {
  // hooks
  const { t } = useTranslation()
  const { roles } = useUser()
  const queryClient = useQueryClient()
  const { ticketById, isTicketByIdLoading } = useTicketsById()
  const { setIsDeleteTicketModalOpen } = useHandleDeleteTicketModal()
  const { ticketToEdit, setTicketToEdit, setIsTicketModalOpen, isTicketModalOpen } =
    useHandleTicketModal()
  const { assignmentTickets, carrierAvailabilityIsEnabled, maxAllowedDaysForSupplierRequest } =
    useConfigurationProperties()
  const { addNote } = useNote()
  const [form] = Form.useForm()
  const [formNotes] = Form.useForm()

  // states
  const [editable, setEditable] = useState<boolean>()
  const [isWarning, setIsWarning] = useState<boolean>()
  const [assignValue, setAssignValue] = useState<'manual' | 'automatic'>()
  const [ifToApproved, setIfToApproved] = useState<boolean>()
  const [dates, setDates] = useState<Date[]>()
  const [primaryButtonIsDisabled, setPrimaryButtonIsDisabled] = useState<boolean>()
  const [activeTab, setActiveTab] = useState<TabValue>()
  const [noteContent, setNoteContent] = useState<string>()

  const handleSetNoteContent = (e: ChangeEvent<HTMLTextAreaElement>) => {
    setNoteContent(e.target.value)
  }

  const handlePrimaryButtonDisabling = (value: boolean) => {
    setPrimaryButtonIsDisabled(!!value)
  }

  const resetModal = useCallback(() => {
    setTicketToEdit(0)
    setIsTicketModalOpen(false)
    queryClient.removeQueries([TICKET, PURCHASES])
    notification.destroy('validationError')
    // self states
    setEditable(undefined)
    setIsWarning(undefined)
    setAssignValue(undefined)
    setIfToApproved(undefined)
    setDates(undefined)
    setPrimaryButtonIsDisabled(undefined)
    setActiveTab(undefined)
    setNoteContent(undefined)
  }, [ticketToEdit])

  const handleCloseModal = () => {
    onClose()
  }

  const handleAfterModalClose = () => {
    setDates(undefined)
  }

  const defaultAssignValue = useMemo(
    () => (assignmentTickets === 'true' ? 'automatic' : 'manual'),
    [assignmentTickets],
  )

  const ticketModalHeader = useCallback(() => {
    const modalTitle = ticketToEdit
      ? `${t('globals.generics.request')}${
          ticketById?.ticket?.id ? ` #${ticketById?.ticket?.id}` : ''
        }${
          ticketById?.ticket?.status.name
            ? ` - ${t(`globals.generics.status.${ticketById?.ticket?.status.name.toLowerCase()}`)}`
            : ''
        }`
      : title
    if (
      roles?.includes(ADMIN) &&
      !!(
        ticketById &&
        ((permittedAdminDeleteStatus.includes(
          ticketById?.ticket?.status?.name as StatusTicketEnum,
        ) &&
          dayjs(ticketById?.ticket?.withdrawalDate) > dayjs()) ||
          ticketById?.ticket?.status.name === CREATED)
      )
    ) {
      return modalTitle
    }
    if (
      roles?.includes(ADMINRO) &&
      !!(
        ticketById &&
        ((permittedAdminDeleteStatus.includes(
          ticketById?.ticket?.status?.name as StatusTicketEnum,
        ) &&
          dayjs(ticketById?.ticket?.withdrawalDate) > dayjs()) ||
          ticketById?.ticket?.status.name === CREATED)
      )
    ) {
      return modalTitle
    }
    return modalTitle
  }, [ticketToEdit, ticketById, roles])

  const DinamicTitle: React.FC<PropsWithChildren> = useCallback(
    ({ children }) => (
      <Space className="ticket-modal-header-tools">
        {children}
        {ticketById?.ticket?.id && roles && roles.some(item => ableRolesToShare.includes(item)) && (
          <FlexRow>
            <RedirectToTicket ticketId={ticketById.ticket.id} />
            <ShareTicket ticketId={ticketById.ticket.id} />
          </FlexRow>
        )}
      </Space>
    ),
    [ticketById, roles],
  )

  const proceed = useCallback(() => {
    if (dates?.length === undefined) {
      setIsWarning(true)
    }
    form.setFieldsValue({ datesInput: dates?.length ? true : undefined })
    form
      .validateFields()
      .then(values => {
        const isVirgin =
          ticketToEdit === 0 ||
          (ticketById?.ticket?.status.name === CREATED &&
            !ticketById.ticket.ticketAssignments?.length)

        onOk(
          ticketById?.ticket?.id,
          {
            count: values.count,
            depotId: values.depotId,
            materialId: values.materialId,
            equipmentId: values.equipmentId,
            destinationId: values.destinationId,
            carrierId: values.carrierId,
            note: values.comments ? { description: values.comments } : undefined,
            documentNumberId: values.documentNumberId ?? undefined,
            type: isVirgin ? assignValue || (assignmentTickets ? 'automatic' : 'manual') : 'manual',
            declinedLoad: values.declinedLoad,
            declinedLoadType: values.declinedLoadType,
          },
          handleCloseModal,
          dates,
          !!ifToApproved,
        )
      })
      .catch(() => {
        notification.destroy('validationError')
        notification.error({
          message: t('globals.validation_error'),
          key: 'validationError',
        })
      })
  }, [dates, ticketToEdit, ticketById, assignmentTickets, assignValue, ifToApproved])

  const handleAddNote = useCallback(() => {
    formNotes
      .validateFields()
      .then(({ note }) => {
        addNote({ id: ticketToEdit!, note: { description: note } })
        setNoteContent('')
        formNotes.resetFields()
      })
      .catch(() => {
        notification.error({
          message: 'Revise el campo de agregar notas, formato no permitido.',
        })
      })
  }, [ticketToEdit, noteContent])

  useEffect(() => {
    if (roles) {
      if (ticketById?.ticket) {
        setAssignValue(!!ticketById.ticket?.autoAssign ? 'automatic' : 'manual')
        setIfToApproved(!!(roles.includes(ADMIN) && ticketById.ticket?.status.name === CREATED))
        handlePrimaryButtonDisabling(
          roles.some(role => [SUPPLIER, ADMIN].includes(role))
            ? primaryButtonInitialStateByRole(ticketById.ticket)[roles[0] as 'SUPPLIER' | 'ADMIN']
            : true,
        )
        setIsTicketModalOpen(true)
      }
    }
  }, [ticketById, roles])

  useEffect(() => {
    if (!isTicketModalOpen) {
      resetModal()
    } else if (!ticketToEdit) {
      handlePrimaryButtonDisabling(false)
      if (roles?.includes(ADMIN)) {
        setAssignValue(defaultAssignValue)
      }
    }
  }, [isTicketModalOpen])

  useEffect(() => {
    if (
      isLoading ||
      isTicketByIdLoading ||
      !roles ||
      (!!ticketToEdit && ticketById?.ticket?.id !== ticketToEdit) ||
      primaryButtonIsDisabled === undefined
    ) {
      setActiveTab(undefined)
    } else {
      setActiveTab('1')
    }
  }, [isLoading, isTicketByIdLoading, roles, ticketToEdit, ticketById, primaryButtonIsDisabled])

  useEffect(() => {
    if (!noteContent) {
      formNotes.setFieldsValue({ note: undefined })
    }
  }, [noteContent])

  return isTicketModalOpen ? (
    <StyledModal
      afterClose={handleAfterModalClose}
      destroyOnClose
      keyboard
      maskClosable
      className={`create-edit-modal ${!!(ticketById && !editable) && 'detail-modal'}`}
      open={isTicketModalOpen}
      onCancel={handleCloseModal}
      title={<DinamicTitle>{ticketModalHeader()}</DinamicTitle>}
      closeIcon={<CloseOutlined />}
      cancelText={t('suppliers_router.new_ticket_modal.cancelText')}
      footer={
        !roles?.includes(ADMINRO) && [
          <Button key="cancelar" onClick={handleCloseModal} target="closeModalButton">
            {t('suppliers_router.new_ticket_modal.cancelText')}
          </Button>,
          <Button
            type="primary"
            key="ok"
            onClick={proceed}
            disabled={!activeTab || primaryButtonIsDisabled}
          >
            {!!ifToApproved
              ? t('suppliers_router.new_ticket_modal.authorize')
              : t('suppliers_router.new_ticket_modal.okText')}
          </Button>,
          roles?.includes(ADMIN) &&
            !!(
              ticketById &&
              ((permittedAdminDeleteStatus.includes(
                ticketById?.ticket?.status?.name as StatusTicketEnum,
              ) &&
                dayjs(ticketById?.ticket?.withdrawalDate) > dayjs()) ||
                ticketById?.ticket?.status.name === CREATED)
            ) && (
              <Button
                onClick={() => setIsDeleteTicketModalOpen(true)}
                key="eliminar"
                type="primary"
                danger
                ghost
              >
                {t('ticket_modal.button_delete')}
                <DeleteTwoTone twoToneColor="#cc3c37" />
              </Button>
            ),
        ]
      }
    >
      {!!activeTab ? (
        <Tabs
          activeKey={activeTab}
          onTabClick={activeKey => {
            setActiveTab(activeKey as TabValue)
          }}
          items={[
            {
              label: t('ticket_modal.tab_info'),
              children: (
                <TicketForm
                  ticket={ticketById?.ticket}
                  handlePrimaryButtonDisabling={handlePrimaryButtonDisabling}
                  editable={editable}
                  setEditable={setEditable}
                  dates={dates}
                  setDates={setDates}
                  roles={roles!}
                  isWarning={isWarning}
                  setIsWarning={setIsWarning}
                  ifToApproved={ifToApproved}
                  form={form}
                  setAssignValue={setAssignValue}
                  assignValue={assignValue}
                  carrierAvailabilityIsEnabled={carrierAvailabilityIsEnabled}
                  maxAllowedDaysForSupplierRequest={maxAllowedDaysForSupplierRequest}
                />
              ),
              key: '1',
            },
            ...(ticketById?.ticket && adminRoles.some(role => roles?.includes(role))
              ? [
                  {
                    label: `${t('ticket_modal.tab_notes')}${
                      ticketById?.ticket?.notes?.length ? `(${ticketById.ticket.notes.length})` : ''
                    }`,
                    children: (
                      <>
                        {roles?.includes(ADMINRO) ? null : (
                          <Form form={formNotes} className="note-input-form">
                            <StyledRow className="new-ticket-form-row comments">
                              <Form.Item label={t('globals.generics.note')} name="note">
                                <TextArea
                                  onChange={handleSetNoteContent}
                                  value={noteContent}
                                  maxLength={1200}
                                  rows={3}
                                  allowClear
                                />
                              </Form.Item>
                            </StyledRow>
                            <StyledButton
                              className={`add-note ${!noteContent && 'disabled'}`}
                              disabled={!noteContent}
                              onClick={handleAddNote}
                            >
                              {t('ticket_modal.add_note')}
                            </StyledButton>
                          </Form>
                        )}
                        {ticketById?.ticket?.notes?.map((note: Note) => (
                          <NoteElement data={note} />
                        ))}
                      </>
                    ),
                    key: '2',
                  },
                ]
              : []),
          ]}
        />
      ) : (
        <FlexRow className="ticket-modal-spin-container">
          <Spin className="ticket-modal-spinner" size="large" />
        </FlexRow>
      )}
    </StyledModal>
  ) : null
}
export { TicketModal }
